(function () {
  document.documentElement.classList.add('bb-js');

  var items = document.querySelectorAll('.bb-reveal');
  if (!('IntersectionObserver' in window)) {
    for (var i = 0; i < items.length; i++) items[i].classList.add('is-in');
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    for (var j = 0; j < items.length; j++) io.observe(items[j]);
  }

  try {
    var heads = document.querySelectorAll('.bb-footer__col h4');
    for (var k = 0; k < heads.length; k++) {
      if (heads[k].textContent.trim() !== 'Get in touch') continue;
      var col = heads[k].parentNode;
      if (col.querySelector('.bb-ig')) break;
      var ig = document.createElement('a');
      ig.className = 'bb-ig';
      ig.href = 'https://www.instagram.com/bigbull.marketing/';
      ig.target = '_blank';
      ig.rel = 'noopener';
      ig.textContent = 'Instagram: @bigbull.marketing';
      col.insertBefore(ig, col.querySelector('p'));
      break;
    }
  } catch (e) {}

  try {
    if (document.querySelector('.bb-wa')) return;
    var css = '.bb-wa{position:fixed;right:16px;bottom:16px;z-index:60;display:inline-flex;align-items:center;gap:8px;padding:12px 18px 12px 14px;border-radius:999px;background:#25d366;color:#fff;font:700 14px/1 Montserrat,system-ui,sans-serif;text-decoration:none;box-shadow:0 12px 30px rgba(0,0,0,.45)}' +
      '.bb-wa svg{width:22px;height:22px;fill:currentColor;flex:none}' +
      '.bb-wa:hover{filter:brightness(1.08)}' +
      '.bb-wa:focus-visible{outline:3px solid #fff;outline-offset:3px}' +
      '@media (max-width:520px){.bb-wa{padding:14px}.bb-wa span{display:none}}';
    var style = document.createElement('style');
    style.textContent = css;
    document.head.appendChild(style);

    var msg = encodeURIComponent("Hi Bigbull Marketing, I'd like to know more about your services.");
    var a = document.createElement('a');
    a.className = 'bb-wa';
    a.href = 'https://wa.me/917011139754?text=' + msg;
    a.target = '_blank';
    a.rel = 'noopener';
    a.setAttribute('aria-label', 'Chat with us on WhatsApp');
    a.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.45 1.32 4.95L2 22l5.25-1.38a9.9 9.9 0 0 0 4.79 1.22h.01c5.46 0 9.91-4.45 9.91-9.91C21.96 6.45 17.5 2 12.04 2zm5.82 14.12c-.25.7-1.47 1.34-2.02 1.42-.52.08-1.18.11-1.9-.12-.44-.14-1-.32-1.73-.64-3.04-1.31-5.03-4.38-5.18-4.58-.15-.2-1.24-1.65-1.24-3.15 0-1.5.78-2.23 1.06-2.54.28-.31.6-.38.8-.38.2 0 .4 0 .58.01.19.01.44-.07.69.53.25.6.85 2.08.93 2.23.07.15.12.33.02.53-.1.2-.15.32-.3.5-.15.17-.31.39-.45.52-.15.15-.3.31-.13.6.17.3.76 1.25 1.63 2.02 1.12 1 2.07 1.31 2.36 1.46.3.15.47.13.64-.08.17-.2.74-.86.94-1.16.2-.3.4-.25.67-.15.27.1 1.72.81 2.01.96.3.15.5.22.57.35.07.12.07.72-.18 1.42z"/></svg><span>Chat on WhatsApp</span>';
    document.body.appendChild(a);
  } catch (e) {}
})();